<script lang="ts" setup>
const { enabled: cookieConsentEnabled, openPreferences: openCookiePreferences } = useCookieConsent()
</script>

<template>
  <div
    class="
      border-t border-default py-4 px-6 text-xs
      flex flex-col xl:flex-row gap-2 justify-between
      "
  >
    <p class="text-primal">
      &copy; {{ (new Date).getFullYear() }} Forgd. All rights reserved.
      <a href="/terms-conditions" target="_blank" class="font-semibold text-hyperlink hover:text-hyperlink-hover">
        Terms & Conditions
      </a>
      <template v-if="cookieConsentEnabled">
        &middot;
        <button type="button" class="font-semibold text-hyperlink hover:text-hyperlink-hover" @click="openCookiePreferences()">
          Cookie preferences
        </button>
      </template>
    </p>

    <p class="text-secondary">
      The content on this site is for informational purposes only and should not be construed as financial or legal advice.
    </p>
  </div>
</template>
